import React from 'react';
import { Box } from '@chakra-ui/react';

interface Props {
  data: string;
}

function ReactQuillComponent({ data }: Props) {
  return (
    <Box className="ql-snow">
      <div
        className="ql-editor"
        style={{ padding: 0 }}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: data }}
      />
    </Box>
  );
}

export default ReactQuillComponent;
